export default __webpack_public_path__ + "static/media/misc-pantry2-1920w.6de544d6.webp";